import { FC } from 'react'
import type { TUniversity } from '../../types'
import UniversityItem from './components/university-item'
import { cn } from '@src/design-system/helpers'

const UniversityCustomFields: FC<{ university: TUniversity, modal?: boolean }> = ({ university, modal = true }) => {
    return (
        <div className={cn('space-y-4 p-4 m-4 mt-0 bg-white rounded-xl', !modal && 'm-0 p-0')}>
            <p className='font-semibold text-gray-800'>Custom Fields</p>
            <div className={cn('grid gap-3', modal ? 'grid-cols-1' : 'sm:grid-cols-2 lg:grid-cols-3')}>
                {university?.custom_fields?.map((customField) => (
                    <UniversityItem key={customField.id} label={customField.label} value={customField.value?.value ?? '-'} />
                ))}
            </div>
        </div>
    )
}

export default UniversityCustomFields